// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"Ca","modalContent":"Da","header":"Ea","close":"Fa"};